// extracted by mini-css-extract-plugin
export default {"round":"styles_round__6PfZv","round__heading":"styles_round__heading__1yjys","round__heading__first-column":"styles_round__heading__first-column__XgZ0P"};